const madeModal = document.querySelector("#madeOfferModal");
if (madeModal && madeModal.parentNode !== document.body) {
  document.body.appendChild(madeModal);
}


function openMadeOfferModal() {
  const modal = document.querySelector("#madeOfferModal");
  modal.classList.add('open');
  document.querySelector('.template-product').style.overflow = "hidden";
}


  function closeMadeOfferModal() {
    const modal = document.querySelector("#madeOfferModal");
    modal.classList.remove('open');
    document.querySelector('.template-product').style.overflow = "unset";
  }
  
  document.querySelector(".mao-modal-btn").addEventListener("click", openMadeOfferModal);
  document.querySelector(".offer-modal-close-btn").addEventListener("click", closeMadeOfferModal);


  
  document.addEventListener("click", function(event) {
    const modal = document.querySelector("#madeOfferModal");
    const modalContent = modal.querySelector(".modal-content"); 
    const wtiButton = document.querySelector('.mao-modal-btn');
  
    if (!modalContent.contains(event.target) && event.target !== wtiButton) {
      closeMadeOfferModal();
    }
  });
  
    document.addEventListener("DOMContentLoaded", function () {
      var urlParams = new URLSearchParams(window.location.search);
      var contactPosted = urlParams.get('form_type');
      const form = document.querySelector('.mao-contact-form');
      const successMessage = document.querySelector('.modal-success-message');
      
      if (contactPosted === "contact") {
        // Optional: Clean the URL
        if (history.replaceState) {
            const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
            history.replaceState(null, null, cleanUrl);
        }
      } else {
        if (form) form.classList.remove("hidden");
        if (successMessage) successMessage.classList.add("hidden");
      }
    });
  

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("#made_contact_form");
  var urlParams = new URLSearchParams(window.location.search);
  var contactPosted = urlParams.get('form_type');
  const successMessage = document.querySelector('.modal-success-message');
  if (!form) return;

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    contactPosted = "made";
    openMadeOfferModal();
    if (form) form.classList.add("hidden");
    if (successMessage) successMessage.classList.remove("hidden");

    // Get form values
    const productName = form.querySelector(
      'input[name="contact[product_name]"]'
    )?.value;
    const productPrice = form.querySelector(
      'input[name="contact[product_price]"]'
    )?.value;
    const priceOffer = form.querySelector(
      'input[name="contact[body]"]'
    )?.value;
    const name = form.querySelector('input[name="contact[name]"]')?.value;
    const email = form.querySelector('input[name="contact[email]"]')?.value;
    const phone = form.querySelector('input[name="contact[phone]"]')?.value;

    if (typeof gtag === 'function') {
      gtag('event', 'gtm.formSubmit', {
        event_category: 'Contact Form',
        event_label: 'Make Offer Form',
        form_type: 'Contact',
        value: 1
      });      
    }

    // OR if using Google Tag Manager’s dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'gtm.formSubmit',
      form_name: 'Make Offer Form',
      form_type: 'Contact'
    });

    if (!window._klOnsite) {
      console.error("Klaviyo library not loaded.");
      return;
    }

    // Identify customer (optional, but recommended)
    _klOnsite.push([
      "identify",
      {
        $email: email,
        $first_name: name,
        $phone_number: phone,
        product_price: productPrice,
        price_offer: priceOffer,
        product_name: productName,
      },
    ]);

    // Track custom event
    _klOnsite.push([
      "track",
      "Make-Offer",
      {
        product_name: productName,
        product_price: productPrice,
        email: email,
        first_name: name,
        phone_number: phone,
        price_offer: priceOffer,
        submitted_at: new Date().toISOString(),
      },
    ]);

    form.reset();
  });
});